import { v4 } from 'uuid'

import { gql } from '@apollo/client'

import { client } from '../client'

export interface RefreshTokenServerResponseType {
	refreshJwtAuthToken: {
		authToken: string
		clientMutationId: string
		__typename: 'RefreshJwtAuthTokenPayload'
	}
}

export const REFRESH_TOKEN = gql`
	mutation ($input: RefreshJwtAuthTokenInput!) {
		refreshJwtAuthToken(input: $input) {
			authToken
			clientMutationId
		}
	}
`

export const refreshToken = (refreshToken: string) => {
	return client.mutate<RefreshTokenServerResponseType>({
		variables: {
			input: {
				clientMutationId: v4(),
				jwtRefreshToken: refreshToken,
			},
		},
		mutation: REFRESH_TOKEN,
	})
}
